import React from "react";
import { IFaqProp, } from "../../../types";
import GetComponent from "../../websiteTemplates/_GetComponent";
import { useSalesChannel } from "../../../context/SalesChannelContext";
import { FAQsProps } from "../../websiteTemplates/Default/FAQs";

interface FaqProps {
    data: IFaqProp;
}

export default function Faq({ data }: FaqProps) {

    const salesChannel = useSalesChannel();

    if (data?.faqs && data.faqs.length > 0) {
        return (
            <div className="editor-renderer">
                <GetComponent template={salesChannel.websiteTemplate} component="FAQs" props={{ faqs: data.faqs } as FAQsProps} />
            </div>
        );
    }

    return null;
}
